import styled from 'styled-components';
import {DEVICE} from '@chekin/guestapp-ui-kit';
import {MultiRadio} from 'components/common/MultiRadio/MultiRadio';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px 0;
  width: 100%;
  gap: 16px;

  @media (min-width: ${DEVICE.laptop}) {
    margin-top: 48px;
  }
`;

export const ContentSelectOption = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const MultiRadioStyled = styled(MultiRadio)`
  gap: 24px;

  & .multi-radio__option > div {
    width: 100%;
  }
  & .multi-radio__label {
    color: ${({theme}) =>
      theme.hasTemplate ? theme.colors.branding.fontSecondary : theme.colors.$p10};
    font-size: ${({theme}) => theme.fonts.sizes.large};
    font-weight: ${({theme}) => theme.fonts.fontWeight.mediumL};
    padding: 24px;
    width: 100%;

    &:before {
      margin-right: 16px;
    }
  }
`;

export const ContentButton = styled.div`
  margin: 48px auto;

  @media (min-width: ${DEVICE.laptop}) {
    margin: 48px 0;
  }
`;
